/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AiRunStep = {
    id: string;
    aiRunId: string;
    error?: string | null;
    exception?: string | null;
    stepDetails?: {
        type?: AiRunStep.type;
        message_creation?: {
            message_id?: string;
        } | null;
        tool_calls?: {
            function_name?: string | null;
            calls?: Array<Record<string, any>> | null;
        } | null;
        indexing?: {
            progress?: number;
            current_item?: string;
            total_items?: number;
            current_item_progress?: number;
        } | null;
        tool_execution?: {
            tool_name?: string;
            status?: AiRunStep.status;
            queries?: Array<string> | null;
            search_type?: string | null;
            target_urls?: Array<string> | null;
            error?: string | null;
            urls?: Array<{
                url?: string;
                title?: string | null;
                description?: string | null;
                faviconUrl?: string | null;
                siteName?: string | null;
                status?: string;
            }> | null;
        } | null;
    } | null;
    completedAt?: string | null;
    createdAt: string;
    updatedAt: string;
};
export namespace AiRunStep {
    export enum type {
        MESSAGE_CREATION = 'message_creation',
        TOOL_CALLS = 'tool_calls',
        INDEXING = 'indexing',
        TOOL_EXECUTION = 'tool_execution',
    }
    export enum status {
        INITIAL = 'initial',
        IN_PROGRESS = 'in_progress',
        COMPLETED = 'completed',
        FAILED = 'failed',
        CANCELLED = 'cancelled',
    }
}

